import "../chunk-LRC6LAHC.mjs";
import "../chunk-OSOWFQSI.mjs";
import {
  useRechargeWallet
} from "../chunk-MWZPRLHJ.mjs";
import {
  useGetTransactionById
} from "../chunk-IX4AP3GG.mjs";
import "../chunk-O5EKO7IJ.mjs";
import {
  useAnswerSurvey
} from "../chunk-EIHJ6PC2.mjs";
import {
  useGetSurvey
} from "../chunk-I2RLO6QK.mjs";
import "../chunk-EIK5AIZL.mjs";
import {
  useGetTeamsList
} from "../chunk-X5P7ZINL.mjs";
import {
  useGetWalletHistory
} from "../chunk-MKTBAA64.mjs";
import "../chunk-5JSYNTRB.mjs";
import {
  useGetHoldToken
} from "../chunk-OJUO5YG4.mjs";
import "../chunk-ODHGRMV4.mjs";
import {
  useGetSubscriptionPlans
} from "../chunk-D2EG7ZNC.mjs";
import {
  useGetSubscriptionById,
  useGetUserSubscriptions
} from "../chunk-JALTRAPN.mjs";
import {
  useGetSubscriptionActions
} from "../chunk-3PDXDKNU.mjs";
import {
  useGetBillingHistory
} from "../chunk-JAZFC4DA.mjs";
import {
  useCancelSubscription
} from "../chunk-7OQMZJJ2.mjs";
import {
  useCheckoutStreamWithCredit,
  useCheckoutSubscription
} from "../chunk-LP26BILC.mjs";
import {
  useGetSubscriptions
} from "../chunk-2GWVVAPC.mjs";
import "../chunk-4SJVSJPB.mjs";
import {
  useRegisterCompetition
} from "../chunk-MFKG2ZJ3.mjs";
import "../chunk-VFTJGEUP.mjs";
import {
  useVerifySaudiRewards
} from "../chunk-ZEPFLZCF.mjs";
import "../chunk-JHCTAEQN.mjs";
import {
  useGetSeason
} from "../chunk-D4T2G3OD.mjs";
import "../chunk-ZZUXNT7S.mjs";
import "../chunk-3NAM65ON.mjs";
import {
  useGetTicketingPackage
} from "../chunk-4OJY2MX7.mjs";
import "../chunk-S2JMW6YP.mjs";
import {
  useRedeemQitaf
} from "../chunk-CIDA366E.mjs";
import {
  useSendQitafOtp
} from "../chunk-X5UKCPAS.mjs";
import "../chunk-YHJGQ5NE.mjs";
import {
  useServmeShifts
} from "../chunk-YHCBYGKV.mjs";
import {
  useSevenRoomsTables
} from "../chunk-JNYM76KL.mjs";
import {
  useSevenRoomsAvailability
} from "../chunk-YTLYKZWO.mjs";
import "../chunk-7HR4YN4U.mjs";
import {
  useCheckNafath
} from "../chunk-UMR52QZL.mjs";
import {
  useRequestNafath
} from "../chunk-ULAZCJCA.mjs";
import "../chunk-G7BCRYVW.mjs";
import {
  useSubscribe
} from "../chunk-J7ZTUCDN.mjs";
import {
  useGetOrganizationBySlug
} from "../chunk-OENBTZFE.mjs";
import "../chunk-2LHFK2NZ.mjs";
import {
  useGeoLocation
} from "../chunk-ER5QWX2V.mjs";
import "../chunk-E6RGKVAL.mjs";
import {
  useRegisterInterest
} from "../chunk-RWIPBRD3.mjs";
import {
  useTicketInterest
} from "../chunk-YJAJBNYT.mjs";
import "../chunk-U5RW6XEF.mjs";
import {
  useMerchandiseProducts
} from "../chunk-K6HDPFOR.mjs";
import {
  useGetMerchandiseProduct
} from "../chunk-S77WHWLC.mjs";
import {
  useHoldProducts
} from "../chunk-GHIIDUJF.mjs";
import "../chunk-HDQDOF5J.mjs";
import {
  useSelectedFlight
} from "../chunk-RHLIJJFP.mjs";
import {
  useFlightsCheckout
} from "../chunk-C66CB5B5.mjs";
import {
  useFareFamilies
} from "../chunk-R4QGZAV3.mjs";
import {
  useDownloadInvoice
} from "../chunk-Y3PRL2DD.mjs";
import {
  useGetFlightOrder,
  useGetFlightsOrders
} from "../chunk-S3DICKNE.mjs";
import {
  useCreatePassenger,
  useDeletePassenger,
  useGetAllPassengers,
  useGetPassenger,
  useUpdatePassenger
} from "../chunk-H7Q4YDSJ.mjs";
import {
  useReserveFlight
} from "../chunk-76JJPA7Z.mjs";
import {
  useSearchFlights
} from "../chunk-CKZ4YMH2.mjs";
import "../chunk-NZL6PEZS.mjs";
import {
  useGetFavoriteEvent
} from "../chunk-6TH3B2U7.mjs";
import {
  useGetInterestOptions
} from "../chunk-V4UF3YL6.mjs";
import {
  useToggleUserFavorite
} from "../chunk-MVD3I5QK.mjs";
import {
  useUpdateUserInterests
} from "../chunk-W6RTPVFY.mjs";
import {
  useGetUserFavorites
} from "../chunk-SWCBMWE3.mjs";
import {
  useAirports,
  usePopularAirports
} from "../chunk-EHZBKXR2.mjs";
import "../chunk-YPGFGVRX.mjs";
import {
  useGetTicketingEventSlots
} from "../chunk-X2WKX7WM.mjs";
import {
  useEventsList,
  useEventsListByOrganizationSlug
} from "../chunk-6INE5MCD.mjs";
import {
  useGetEventPerks
} from "../chunk-V2AVRCXK.mjs";
import {
  useGetEventQuestions
} from "../chunk-H4IZQSX6.mjs";
import {
  useGetEventResaleTickets
} from "../chunk-XTSRIEK3.mjs";
import {
  useGetEventTickets
} from "../chunk-NN2QL2VA.mjs";
import "../chunk-YQK2UFMR.mjs";
import {
  useGetFaqsList
} from "../chunk-MOYBVKTI.mjs";
import "../chunk-X7CUQC4Y.mjs";
import {
  useGetSupportedCurrencies
} from "../chunk-ZGHPKC6J.mjs";
import "../chunk-XUTYQBME.mjs";
import {
  useActivateDevice
} from "../chunk-XUVF4QVE.mjs";
import {
  useGetEventAddonsById
} from "../chunk-YYDM5NPV.mjs";
import {
  useGetTicketingEvent
} from "../chunk-FYBKLMLH.mjs";
import {
  useGetEventGroupBySlug
} from "../chunk-Q335VIGP.mjs";
import {
  useGetUserEventLimits
} from "../chunk-RAUNV3FU.mjs";
import "../chunk-VPROHC3W.mjs";
import {
  useGetCities
} from "../chunk-DM5RG42C.mjs";
import "../chunk-RJ7PV2AC.mjs";
import {
  useContactUs
} from "../chunk-3SA7GWBC.mjs";
import "../chunk-NGR77FSJ.mjs";
import {
  useVerifyCoupon
} from "../chunk-OMUHQDM4.mjs";
import "../chunk-LXUPBY2I.mjs";
import {
  useGetHyExperienceOrderById,
  useGetOrderById
} from "../chunk-M2E5KODH.mjs";
import "../chunk-JJDHBOQ6.mjs";
import {
  useBusiness
} from "../chunk-27JXYD3N.mjs";
import "../chunk-UF2ZH2HE.mjs";
import {
  useGetUserDigitalCardById
} from "../chunk-6SNNQS4H.mjs";
import {
  useGetUserDigitalCards
} from "../chunk-DJNQ6AJB.mjs";
import {
  useGetDigitalCards
} from "../chunk-XBGEW3DE.mjs";
import {
  useTopUpCard
} from "../chunk-5UM5J5FJ.mjs";
import {
  useGetTopUpTransactionbyId
} from "../chunk-PG2KFFSN.mjs";
import {
  useApplePayPaymentProceed,
  useApplePayPaymentSession
} from "../chunk-BLPWJ2KM.mjs";
import {
  useGetBluBookings,
  useGetBookings,
  useGetHyExperiencesBookings
} from "../chunk-6UVSXJKZ.mjs";
import {
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useValidateOfflineOrderToken
} from "../chunk-DW4IFFZJ.mjs";
import {
  useDownloadReceipt,
  useDownloadTicket
} from "../chunk-I3D3MN4B.mjs";
import {
  useGetGeneratedPayment
} from "../chunk-USHMWN5U.mjs";
import "../chunk-CRHF7AQR.mjs";
import {
  useRegister,
  useSignup
} from "../chunk-RMFFDKD2.mjs";
import {
  useGetTawakkalnaUser,
  useLinkTawakkalnaUser
} from "../chunk-EFDYMUN5.mjs";
import {
  useGetUser
} from "../chunk-FK3OZNK2.mjs";
import {
  useSendOtpToEmail,
  useUpdateEmail,
  useVerifyEmail
} from "../chunk-LYMMZRKM.mjs";
import {
  useLogin
} from "../chunk-7ANTOXLV.mjs";
import {
  useLogout
} from "../chunk-5BKUZGK5.mjs";
import {
  useResendOtp,
  useSendOtp,
  useVerifyOtp
} from "../chunk-SNGRFUCO.mjs";
import {
  useChangePassword,
  useForgotPassword
} from "../chunk-Z4P4YPW7.mjs";
import {
  useUpdateProfile
} from "../chunk-SY76PGO6.mjs";
import "../chunk-YXUQEZWU.mjs";
import {
  useRequestDisabilityTickets
} from "../chunk-S5IOXISW.mjs";
import "../chunk-OKQHTXUJ.mjs";
import {
  useCheckoutAuctionPayment,
  useGetAuctionPaymentDetails
} from "../chunk-ZB2UY72N.mjs";
import {
  useGetAuctionHistory
} from "../chunk-UXXIBVRN.mjs";
import "../chunk-S4DBG2UM.mjs";
import "../chunk-KEWTJQOK.mjs";
import {
  useBlogList
} from "../chunk-CZ7HZWJ7.mjs";
import "../chunk-FOJMTK4I.mjs";
import "../chunk-BKWZJPJV.mjs";
import {
  useGetExperiencesByCategory
} from "../chunk-SZXZZCVQ.mjs";
import {
  useGetExperienceBySlug
} from "../chunk-N2Z72SK6.mjs";
import "../chunk-FXLMWHDY.mjs";
import {
  useVerifyHyCoupon
} from "../chunk-3TQB3RXV.mjs";
import "../chunk-7CPUYQCC.mjs";
import {
  useShopProducts
} from "../chunk-LYX7N3I3.mjs";
import "../chunk-YAFEA4GV.mjs";
import "../chunk-JIFFPSED.mjs";
import "../chunk-FY4U22RN.mjs";
import "../chunk-KYWS2TJG.mjs";
import "../chunk-GVDXNYBZ.mjs";
import "../chunk-IL34TLOI.mjs";
import "../chunk-47V255NO.mjs";
import "../chunk-LXP64WYJ.mjs";
import "../chunk-RATRWSNO.mjs";
import "../chunk-MXTDD7S4.mjs";
import "../chunk-KXRLHAPZ.mjs";
import "../chunk-XQSBA2MC.mjs";
import "../chunk-PVKP426M.mjs";
import "../chunk-4WXYMJKJ.mjs";
import "../chunk-JMB4EYSN.mjs";
import "../chunk-RIPSFUK2.mjs";
import "../chunk-BYK6XBGD.mjs";
import "../chunk-ZC4X5O7T.mjs";
import "../chunk-DRIP5NSH.mjs";
import "../chunk-BDC2UVDS.mjs";
import "../chunk-P6JUTAOY.mjs";
import "../chunk-WKI5B7WG.mjs";
import "../chunk-VUFEVYR6.mjs";
import "../chunk-X5XXBQBA.mjs";
import "../chunk-RVMXYXS3.mjs";
import "../chunk-CUT7YX2I.mjs";
import "../chunk-PFRPPHW3.mjs";
import "../chunk-YJRK7R47.mjs";
import "../chunk-UGWT7YSQ.mjs";
import "../chunk-PCEF24UO.mjs";
import "../chunk-YHJAGYFE.mjs";
import "../chunk-5YESQLVX.mjs";
import "../chunk-NCW3PHK5.mjs";
import "../chunk-UFJGLWWE.mjs";
import "../chunk-PRLFENP2.mjs";
import "../chunk-EH7PFRXG.mjs";
import "../chunk-SAJLN2Y4.mjs";
import "../chunk-GBRSAZWM.mjs";
import "../chunk-RONAXZBM.mjs";
import "../chunk-NX7DX2HC.mjs";
import "../chunk-KIYXM7VP.mjs";
import "../chunk-OOCNWL2W.mjs";
import "../chunk-5AZN4VUL.mjs";
import "../chunk-DWOMOZDJ.mjs";
import "../chunk-AM6KDUML.mjs";
import "../chunk-JI5U5XIQ.mjs";
import "../chunk-IQHKNSNK.mjs";
import "../chunk-56QEENOZ.mjs";
import "../chunk-H3BAINZ7.mjs";
import "../chunk-WGGKDFOU.mjs";
import "../chunk-FEUIEVLU.mjs";
import "../chunk-FUIG6CYY.mjs";
import "../chunk-MPOZWOTP.mjs";
import "../chunk-7D6VTW7J.mjs";
import "../chunk-HRICWLX6.mjs";
import "../chunk-RU7JTQG6.mjs";
import "../chunk-PMDLPOJM.mjs";
import "../chunk-IU2M4I7O.mjs";
import "../chunk-FKYUOZ3E.mjs";
import "../chunk-UWUX3UL5.mjs";
import "../chunk-HUQY4P34.mjs";
import "../chunk-4G3V5H6E.mjs";
import "../chunk-QEAPYZKB.mjs";
import "../chunk-NXPEYOHQ.mjs";
import "../chunk-MAFZ4IXM.mjs";
import "../chunk-N7WOQ7B5.mjs";
import "../chunk-VVUEFUKX.mjs";
import "../chunk-RFON2F2H.mjs";
import "../chunk-CUQKYHNP.mjs";
import "../chunk-ZQP2RVBN.mjs";
import "../chunk-C5T2WZ6D.mjs";
import "../chunk-7OK33QSG.mjs";
import "../chunk-KERMTD33.mjs";
import "../chunk-KSN6NPSV.mjs";
import "../chunk-DH5WDOLV.mjs";
import "../chunk-V76HGROL.mjs";
import "../chunk-RD4CIFKQ.mjs";
import "../chunk-XGYFVYME.mjs";
import "../chunk-X4LBTNIN.mjs";
import "../chunk-FCSMFK3U.mjs";
import "../chunk-27YX3545.mjs";
import "../chunk-QQEG4KHY.mjs";
import "../chunk-MZJXKPOM.mjs";
import "../chunk-3OY34A2S.mjs";
import "../chunk-XLYMGK6X.mjs";
import "../chunk-MILZ6BWO.mjs";
import "../chunk-PV5KIJUU.mjs";
import "../chunk-2STLQPO2.mjs";
import "../chunk-HSA6GNMK.mjs";
import "../chunk-74B6WKMD.mjs";
import "../chunk-656IUB4B.mjs";
import "../chunk-FRQRMYBL.mjs";
import "../chunk-TW72F3BE.mjs";
import "../chunk-YROKKDJX.mjs";
import "../chunk-TPXT547C.mjs";
import "../chunk-BH6MRFPJ.mjs";
import "../chunk-UJTIFYG5.mjs";
import "../chunk-L4CD37GR.mjs";
import "../chunk-VRFQUQ4L.mjs";
import "../chunk-TEC66KCK.mjs";
import "../chunk-ZWXNWMXL.mjs";
import "../chunk-4LZLOAFS.mjs";
import "../chunk-WJEYPIHE.mjs";
import "../chunk-43UFPVRA.mjs";
import "../chunk-44TNZFFP.mjs";
import "../chunk-TXVZA2CU.mjs";
import "../chunk-XTIEVMBH.mjs";
import "../chunk-JIIZLDZ6.mjs";
import "../chunk-KVUL37HD.mjs";
import "../chunk-MYAVF3P2.mjs";
import "../chunk-AQAOX4IV.mjs";
import "../chunk-Q7DTM46Z.mjs";
import "../chunk-IDRAWCQV.mjs";
import "../chunk-7XWBBWMY.mjs";
import "../chunk-FEFRDEYL.mjs";
import "../chunk-LACSACC3.mjs";
import "../chunk-3PCNV5OU.mjs";
import "../chunk-BFAWQTPE.mjs";
import "../chunk-RIHYP73M.mjs";
import "../chunk-4UT3YPOI.mjs";
import "../chunk-765NQUHW.mjs";
import "../chunk-LUGUSHUV.mjs";
import "../chunk-MXP7K5DX.mjs";
import "../chunk-ZI4WAXZU.mjs";
import "../chunk-VNAI6LR7.mjs";
import "../chunk-B3QVRXFB.mjs";
import "../chunk-FG6TVU6B.mjs";
import "../chunk-3HCEPDN2.mjs";
import "../chunk-OTZHFFCM.mjs";
import "../chunk-CBIK6ZLK.mjs";
import "../chunk-VFRBTVYA.mjs";
import "../chunk-EIW2CIXT.mjs";
import "../chunk-E34LUH6G.mjs";
import "../chunk-YWTSVXV6.mjs";
import "../chunk-75FO4HW4.mjs";
import "../chunk-NMBT7PIE.mjs";
import "../chunk-UNBAXGWG.mjs";
import "../chunk-MIEUWCQU.mjs";
import "../chunk-FOJHN6HD.mjs";
import "../chunk-E4XMY3JC.mjs";
import "../chunk-46OLU47T.mjs";
import "../chunk-WWLG26XU.mjs";
import "../chunk-SKVXOXWB.mjs";
import "../chunk-LPVQMOLH.mjs";
import "../chunk-IZ43CSAA.mjs";
import "../chunk-K342ITN7.mjs";
import "../chunk-W4XMZLKW.mjs";
import "../chunk-LPIRJEMY.mjs";
import "../chunk-DFMI36TU.mjs";

// src/hooks/provider.tsx
import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { jsx, jsxs } from "react/jsx-runtime";
var localDefaults = {
  queries: {
    retry: 0,
    refetchOnWindowFocus: false
  },
  mutations: {
    retry: 0
  }
};
var QueryProvider = ({ children, defaults }) => {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: defaults || localDefaults })
  );
  return /* @__PURE__ */ jsxs(QueryClientProvider, { client: queryClient, children: [
    children,
    /* @__PURE__ */ jsx(ReactQueryDevtools, {})
  ] });
};
export {
  QueryProvider,
  useActivateDevice,
  useAirports,
  useAnswerSurvey,
  useApplePayPaymentProceed,
  useApplePayPaymentSession,
  useBlogList,
  useBusiness,
  useCancelSubscription,
  useChangePassword,
  useCheckNafath,
  useCheckoutAuctionPayment,
  useCheckoutStreamWithCredit,
  useCheckoutSubscription,
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useContactUs,
  useCreatePassenger,
  useDeletePassenger,
  useDownloadInvoice,
  useDownloadReceipt,
  useDownloadTicket,
  useEventsList,
  useEventsListByOrganizationSlug,
  useFareFamilies,
  useFlightsCheckout,
  useForgotPassword,
  useGeoLocation,
  useGetAllPassengers,
  useGetAuctionHistory,
  useGetAuctionPaymentDetails,
  useGetBillingHistory,
  useGetBluBookings,
  useGetBookings,
  useGetCities,
  useGetDigitalCards,
  useGetEventAddonsById,
  useGetEventGroupBySlug,
  useGetEventPerks,
  useGetEventQuestions,
  useGetEventResaleTickets,
  useGetEventTickets,
  useGetExperienceBySlug,
  useGetExperiencesByCategory,
  useGetFaqsList,
  useGetFavoriteEvent,
  useGetFlightOrder,
  useGetFlightsOrders,
  useGetGeneratedPayment,
  useGetHoldToken,
  useGetHyExperienceOrderById,
  useGetHyExperiencesBookings,
  useGetInterestOptions,
  useGetMerchandiseProduct,
  useGetOrderById,
  useGetOrganizationBySlug,
  useGetPassenger,
  useGetSeason,
  useGetSubscriptionActions,
  useGetSubscriptionById,
  useGetSubscriptionPlans,
  useGetSubscriptions,
  useGetSupportedCurrencies,
  useGetSurvey,
  useGetTawakkalnaUser,
  useGetTeamsList,
  useGetTicketingEvent,
  useGetTicketingEventSlots,
  useGetTicketingPackage,
  useGetTopUpTransactionbyId,
  useGetTransactionById,
  useGetUser,
  useGetUserDigitalCardById,
  useGetUserDigitalCards,
  useGetUserEventLimits,
  useGetUserFavorites,
  useGetUserSubscriptions,
  useGetWalletHistory,
  useHoldProducts,
  useLinkTawakkalnaUser,
  useLogin,
  useLogout,
  useMerchandiseProducts,
  usePopularAirports,
  useRechargeWallet,
  useRedeemQitaf,
  useRegister,
  useRegisterCompetition,
  useRegisterInterest,
  useRequestDisabilityTickets,
  useRequestNafath,
  useResendOtp,
  useReserveFlight,
  useSearchFlights,
  useSelectedFlight,
  useSendOtp,
  useSendOtpToEmail,
  useSendQitafOtp,
  useServmeShifts,
  useSevenRoomsAvailability,
  useSevenRoomsTables,
  useShopProducts,
  useSignup,
  useSubscribe,
  useTicketInterest,
  useToggleUserFavorite,
  useTopUpCard,
  useUpdateEmail,
  useUpdatePassenger,
  useUpdateProfile,
  useUpdateUserInterests,
  useValidateOfflineOrderToken,
  useVerifyCoupon,
  useVerifyEmail,
  useVerifyHyCoupon,
  useVerifyOtp,
  useVerifySaudiRewards
};
//# sourceMappingURL=index.mjs.map